import React, { useReducer, useState, useEffect } from 'react';
import style from '../carriage/CarriageEdit.module.css';
import axios from '../../functions/axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuthContext } from '../../hooks/useAuthContext';
import DropdownList from 'react-widgets/DropdownList';
import { DatePicker, Localization } from 'react-widgets';
import { DateLocalizer } from 'react-widgets/IntlLocalizer';
import moment from 'moment';
import "react-widgets/styles.css";
import '../carriage/EditCarriage.css';
import { parseDate } from '../../functions/functions';

function EditCarriage() {
  const location = useLocation();
  const [submitting, setSubmitting] = useState(false);
  const [carrier, setCarrier] = useState([]);
  const [contractor, setContractor] = useState([]);
  const navigate = useNavigate();
  const { user } = useAuthContext();

  const formReducer = (state, event) => {
    return {
      ...state,
      [event.name]: event.value,
    };
  };

  const [formData, setFormData] = useReducer(formReducer, {
    carriageDayStop: location.state?.carriageDayStop || new Date(),
    carriageDayStart: location.state?.carriageDayStart || new Date(),
    routeStart: location.state?.routeStart || '', // string
    routeEnd: location.state?.routeEnd || '', // string
    carrier: location.state?.carrier || '', // string
    contractor: location.state?.contractor ||'', // number
    carrierCost: location.state?.carrierCost || 0, // number
    contractorCost: location.state?.contractorCost || 0, // number
    carrierInvoice: location.state?.carrierInvoice || '', // string
    contractorInvoice: location.state?.contractorInvoice || '', // string
    currency: 'EUR', //string
  });

  const handleSubmit = async (event) => {
    if (event.target.id !== 'submit') return;
    event.preventDefault();
    event.stopPropagation();
    setSubmitting(true);
    await axios.patch(`/soldCarriage`, { ...formData, _id: location.state._id });
    setTimeout(() => {
      setSubmitting(false);
    }, 3000);
    navigate('/soldCarriageList', { state: { date: formData.carriageDayStart } });
  };

  const handleChange = (event) => {
    const isCheckbox = event.target.type === 'checkbox';
    setFormData({
      name: event.target.name,
      value: isCheckbox ? event.target.checked : event.target.value,
    });
  };

  const handleDeleteCarriage = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (event.target.id !== 'remove') return;

    const confirmBox = window.confirm("Czy chcesz usunąć te dane ?")
    if (confirmBox) {
      await axios.delete(`/soldCarriage`, {
        data: {
          _id: location.state._id,
        }
      });
    }
    navigate('/soldCarriageList', { state: { date: formData.carriageDayStart } });
  };

  return (
    <div className={style.wrapper}>
      <form>
        <div className={style.section}>
          <h2>Edycja</h2>
          {/* <div>
          <p className={style.category2}>Utworzył: {location.state.soldCarriage.creator?.userName} o {new Date(location.state?.soldCarriage?.createdAt).toLocaleString('pl')}</p>
          {location.state?.soldCarriage?.lastEdited?.userName && <p>Edytował: {location.state?.soldCarriage?.lastEdited?.userName} o {new Date(location.state?.carriage?.updatedAt).toLocaleString('pl')}</p>}
        </div> */}
          <br />
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='carrier-data'>
              Nazwa przewoźnika:
            </label>
            <input style={{ width: '432px', marginRight: '10px' }} className={style.weight} id='carrier-data' name='carrier' type='text' onChange={handleChange} value={formData.carrier ?? location.state?.carrier ?? ''} />
          </div>
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='contractor-data'>
              Nazwa kontrahenta:
            </label>
            <input style={{ width: '432px', marginRight: '10px' }} className={style.weight} id='contractor-data' name='contractor' type='text' onChange={handleChange} value={formData.contractor ?? location.state?.contractor ?? ''} />
          </div>
          <div className={style.row}>
            <label className={style.category} htmlFor='carriageDayStart'>
              Data załadunku 
            </label>
            <Localization
                date={new DateLocalizer({
                culture: 'pl-PL',
                firstOfWeek: 1,
              })}
            >
              <DatePicker
                value={new Date(formData.carriageDayStart)}
                valueEditFormat={{ dateStyle: 'long' }}
                valueDisplayFormat={{ dateStyle: 'long' }}
                placeholder='miesiąc/dzień/rok'
                onChange={(value) => handleChange({ target: { name: 'carriageDayStart', value: parseDate(value).day } })}
              />
            </Localization>
            {/* <input type='date' id='day' name='day' onChange={handleChange} value={formData.day || new Date().toISOString()} /> */}
          </div>
          <div className={style.row}>
            <label className={style.category} htmlFor='carriageDayStop'>
              Data rozładunku
            </label>
            <Localization
                date={new DateLocalizer({
                culture: 'pl-PL',
                firstOfWeek: 1,
              })}
            >
              <DatePicker
                value={new Date(formData.carriageDayStop)}
                valueEditFormat={{ dateStyle: 'long' }}
                valueDisplayFormat={{ dateStyle: 'long' }}
                placeholder='miesiąc/dzień/rok'
                onChange={(value) => handleChange({ target: { name: 'carriageDayStop', value: parseDate(value).day } })}
              />
            </Localization>
            {/* <input type='date' id='day' name='day' onChange={handleChange} value={formData.day || new Date().toISOString()} /> */}
          </div>
        </div>
        <hr />
        <div className={style.section}>
          <div className={style.category}>Opis trasy</div>
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='route-start-data'>
              Skąd:
            </label>
            <input style={{ width: '550px', marginRight: '10px' }} id='route-start-data' name='routeStart' type='text' onChange={handleChange} value={formData.routeStart ?? location.state?.routeStart  ?? ''} />
          </div>
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='route-end-data'>
              Dokąd:
            </label>
            <input style={{ width: '550px', marginRight: '10px' }} id='route-end-data' name='routeEnd' type='text' onChange={handleChange} value={formData.routeEnd ?? location.state?.routeEnd ?? ''} />
          </div>
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='carrierCost-data'>
              Stawka przewoźnika:
            </label>
            <input type='number' min='0' step='any' id='carrierCost-data' name='carrierCost' onChange={handleChange} value={formData.carrierCost ?? location.state?.carrierCost ?? 0} />
          </div>
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='contractorCost-data'>
              Stawka nasza:
            </label>
            <input type='number' min='0' step='any' id='contractorCost-data' name='contractorCost' onChange={handleChange} value={formData.contractorCost ?? location.state?.contractorCost ?? 0} />
          </div>
            <div className={style.row}>
            <label className={style.subcategory} htmlFor='currency-data'>
              Waluta:
            </label>
            <select name='currency' id='currency' defaultValue={location.state.currency || 'EUR'} onChange={handleChange}>
              <option value='EUR'>EURO €</option>
              <option value='PLN'>PLN zł</option>
            </select>
          </div>
        </div>
        <hr />
        <div className={style.section}>
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='carrierInvoice-data'>
              Nr faktury przewoźnika
            </label>
            <input style={{ width: '200px', marginRight: '10px' }} id='carrierInvoice-data' name='carrierInvoice' type='text' onChange={handleChange} value={formData.carrierInvoice ?? location.state?.carrierInvoice ?? ''} />
          </div>
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='contractorInvoice-data'>
              Nr faktury nasz
            </label>
            <input style={{ width: '200px', marginRight: '10px' }} id='contractorInvoice-data' name='contractorInvoice' type='text' onChange={handleChange} value={formData.contractorInvoice ?? location.state?.contractorInvoice ?? ''} />
          </div>
          <hr />
          <span className={style.buttons}>
            <button id='cancel' className='btn btn-default' onClick={navigate.bind(null, '/soldCarriageList', { state: { date: location.state?.carriageDayStart } })}>
              Anuluj
            </button>
            <button id='remove' className='btn btn-danger' onClick={handleDeleteCarriage}>
              Usuń
            </button>
            <button id='submit' className='btn btn-default' type='submit' onClick={handleSubmit}>
              Zapisz
            </button>
          </span>
        </div>
      </form>
    </div>
  );
}

const getData = async (path, callback) => {
  try {
    const { data: response } = await axios.get(path) || [];
    callback(response);
  } catch (error) {
    console.error(error.message);
  }
};
export default EditCarriage;
